<div class="container-fluid">
  <app-custom-table-title [icon]="icon" [title]="title" [subTitle]="subTitle"></app-custom-table-title>
  <div class="mt-4 mb-4 cf-table-card">

    <ng-template #bankAccountSummary let-data="data">
      <div class="total-card">
        <p class="label">Cuentas <strong>{{ summary.count }}</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Saldo contable total <strong>{{ summary.totalBalance | number:'1.2-2' }} €</strong></p>
      </div>
    </ng-template>

    <ng-template #quickFilter>
      <div class="quick-filter">
        <app-search-filter [value]="quickSearch" placeholder="Buscar entidad, IBAN, cuenta…" (searchChange)="onSearchChange($event)"></app-search-filter>
      </div>
    </ng-template>

    <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>

    <ng-template #expandDetail let-row>
      <app-bank-account-detail [row]="row" (changed)="reload()" (edit)="edit($event)"></app-bank-account-detail>
    </ng-template>
  </div>
</div>
